import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import CTASection from './components/CTASection';
import SEOContentSection from './components/SEOContentSection';
import ArticlePreviewSection from './components/ArticlePreviewSection';
import ArticlesSection from './components/ArticlesSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://pandabuy.study';

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'PandabuySpreadsheet Hub',
  url: siteUrl,
  description: 'Discover the best updated pandabuy spreadsheet hub with curated fashion finds, sneakers, accessories, and lifestyle products. Your trusted source for pandabuyspreadsheet lists updated weekly.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?search={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SchemaOrg data={webSiteSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <SEOContentSection />
        <CTASection />
        <ArticlePreviewSection />
        <ArticlesSection />
      </main>
      <Footer />
    </div>
  );
}